import { useLocation, useParams, useRouteError } from 'react-router'
import { ErrorBoundary } from '#/components/error-boundary'
import { Head } from '#/components/head'
import { Button } from '#/components/ui/button'
import { Separator } from '#/components/ui/separator'
import { Heading } from '#/components/ui/typography'


export default function CustomerError() {
  const params = useParams() as { customer: string }
  const { state } = useLocation()
  const error = useRouteError()

  // Display name might be available from nav state
  const customerName = state?.name ?? params.customer

  return (
    <div className="flex grow flex-col gap-4 items-start">

      <Head title={customerName} />

      <div className="flex w-full items-end justify-between gap-4">
        <Heading>{customerName}</Heading>
        <Button className="invisible" />
      </div>

      <Separator />

      <ErrorBoundary error={error} />

    </div>
  )
}
